import { JobApiService } from './job-api.service';
import JobPublicLinkStatus from '../types/job-public-link-status.type';


interface ResponseDataType {
  status: JobPublicLinkStatus;
  pdf_url: string;
  pdf_id: string;
}


interface RequestParams {
  publicLinkId: string;
  signatures: string[];
}

export const signAndAcceptJobRequest = ({
                                                   publicLinkId,
                                                   signatures
                                                 }: RequestParams): Promise<ResponseDataType> => {
  return JobApiService.makeRequest<ResponseDataType>(`/public/job/${ publicLinkId }/sign-and-accept`, {
    method: 'POST',
    body: {
      signatures,
    }
  });
};